__turbopack_context__.v({
  "pulse": "skeleton-module__nfFdSG__pulse",
  "skeleton": "skeleton-module__nfFdSG__skeleton",
  "sweep": "skeleton-module__nfFdSG__sweep",
});
